import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import * as moment from 'moment-timezone';
import {
  locationMappers,
  typeBasedLocations,
  buttonActions,
} from '../race-reports/locations';
import {
  checkForVenuePermission,
  convertTimestamp,
  getENV,
  getRaceType,
} from 'src/app/_helpers/helpers';
import { APIService } from 'src/app/services/api.service';
import { NotifierService } from 'src/app/services/notifier.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { RacesObject } from '../../../../home/interfaces';
import { typesSelected } from 'src/app/modules/globals/dash/dash.component';

declare var $: any;

// Add this interface near the top of the file
interface RaceTime {
  hour: number;
  minute: number;
  originalHour?: number;
  originalMinute?: number;
}

export enum RaceStatusEN {
  SCHEDULED = 'SCHEDULED',
  ARMED = 'ARM',
  RUNNING = 'RUNNING',
  FINISHED = 'FINISHED',
  'QA_PASSED' = 'QA_PASSED',
  'QA_FAILED' = 'QA_FAILED',
  ABANDONED = 'ABANDONED',
}

interface RaceStatus {
  PLANNED: number;
  DNS: number;
  DNT: number;
  DNF: number;
  DSQ: number;
  OFFICIAL: number;
  FINISHED: number;
  'QA_PASSED': number;
  'QA_FAILED': number;
  PUBLISHED: number;
  ABANDONED: number;
  FTF: number;
  SCR: number;
  'L/SCR': number;
  FELL: number;
  DISTANCE: number;
  RO: number;
  BD: number;
  LB: number;
  LGO: number;
  LGT: number;
}

export interface TimerState {
  startTime: number | null;
  currentTime: string;
  isRunning: boolean;
  lastStatus: RaceStatusEN;
}

export const TIMER_STORAGE_KEY = 'raceTimerState';

interface ButtonAction {
  slug: string;
  status: 'PLANNED' | 'COMPLETED' | 'FAILED';
  actions: Array<{
    name: string;
    status: string;
    comment: string;
  }>;
}

interface ButtonActionConfig {
  name: string;
  action: string;
  type?: string;
  slug: string;
  states: string | string[];
  conditions?: Array<{
    state: string;
    condition: {
      key: string;
      equation: string;
      value: string;
    };
  }>;
}

interface Race {
  ExternalRaceId: string;
  RaceState: string; // Allow both enum and string
  AnimalDetail: any[];
  ReportStatus: any[];
  status: RaceStatus;
  buttonActions?: ButtonAction[];
  raceStatus?: string;
  publishStatus?: string;
  isExpanded?: boolean;
}

interface Race {
  RaceState: string;
  advertisedStartTime: Date;
  // ...other properties
}

@Component({
  selector: 'app-on-course-ops-judges',
  templateUrl: './on-course-ops-judges.component.html',
  styleUrls: [
    './on-course-ops-judges.component.css',
    './../race-reports/race-reports.component.css',
  ],
})
export class OnCourseOpsJudgesComponent
  implements OnInit, OnDestroy, AfterViewInit
{
  date: string = null;
  race_states: string[] = [
    'Scheduled',
    'Arm',
    'Running',
    'PreFinished',
    'Finished',
    'Canceled',
    'QA_PASSED',
    'QA_FAILED',
  ];
  horse_race_states = [
    { name: 'PLANNED', value: 'PLANNED' },
    { name: 'DNS', value: 'DNS' },
    { name: 'DNT', value: 'DNT' },
    { name: 'DNF', value: 'DNF' },
    { name: 'DSQ', value: 'DSQ' },
    { name: 'OFFICIAL', value: 'OFFICIAL' },
    { name: 'FINISHED', value: 'FINISHED' },
    { name: 'QA_PASSED', value: 'QA_PASSED' },
    { name: 'QA_FAILED', value: 'QA_FAILED' },
    { name: 'PUBLISHED', value: 'PUBLISHED' },
    { name: 'ABANDONED', value: 'ABANDONED' },
    { name: 'FTF', value: 'FTF' },
    { name: 'SCR', value: 'SCR' },
    { name: 'L/SCR', value: 'L/SCR' },
    { name: 'FELL', value: 'FELL' },
    { name: 'DISTANCE', value: 'DISTANCE' },
    { name: 'RO', value: 'RO' },
    { name: 'BD', value: 'BD' },
    { name: 'LB', value: 'LB' },
    { name: 'LGO', value: 'LGO' },
    { name: 'LGT', value: 'LGT' }
  ];
  private refreshInterval: any;
  private readonly REFRESH_RATE = 10000; // 10 seconds
  raceTimers: { [key: string]: any } = {};

  nextRace: any = null;
  currentRace: any = null;
  countdownTime: string = '';
  bannerInterval: any;
  heartbeatStatus: boolean = false;
  mylapsStatus: boolean = false;
  completedRaces: number = 0;
  totalRaces: number = 0;
  private statusCheckInterval: any;
  private readonly API_URL =
    'https://50b3p4zwm3.execute-api.ap-southeast-2.amazonaws.com/tsd-prod-api';
  private monitoringInterval: any;

  status: any = {
    lap: 'NoConnection',
    heartbeat: 'down',
  };

  // Add this property to track unsaved time changes
  hasUnsavedTimeChanges: boolean = false;

  async ngAfterViewInit(): Promise<void> {
    this.date = this.date || moment().format('DD MMMM YYYY');
    $('.datetimepicker').val(this.date);
    $('.datetimepicker')
      .datepicker({
        autoclose: true,
        // minViewMode: 1,
        format: 'dd MM yyyy',
        orientation: 'bottom auto',
        endDate: moment().add(2, 'days').toDate(),
      })
      .on('changeDate', (selected: any) => {
        this.date = $('.datetimepicker').val();
        this.fetchEvents();
      });

    setTimeout(() => {
      this.fetchEvents();
    }, 100);
  }

  private isWithin30Seconds(advertisedTime: Date): boolean {
    const now = new Date();
    const timeDiff = advertisedTime.getTime() - now.getTime();
    return timeDiff <= 30000 && timeDiff > 0; // 30 seconds in milliseconds
  }

  async refreshRaces() {
    try {
      // Implement your refresh logic here
      const response = await this.selectEvent(this.selected);
      // Update races array
    } catch (error) {
      console.error('Error refreshing races:', error);
    }
  }

  startRefreshTimer() {
    if (this.refreshInterval) {
      clearInterval(this.refreshInterval);
    }
    this.refreshInterval = setInterval(() => {
      this.fetchRaceStatuses();
    }, 10000); // 10 seconds
  }

  canArm(race: Race): boolean {
    return (
      race.RaceState === 'SCHEDULED' &&
      this.isWithin30Seconds(race.advertisedStartTime)
    );
  }

  canReset(race: Race): boolean {
    return race.RaceState !== 'SCHEDULED';
  }

  canUploadLIF(race: Race): boolean {
    return ['FINISHED', 'OFFICIAL', 'PUBLISHED', 'DNT', 'QA_PASSED', 'QA_FAILED'].includes(
      race.RaceState.toUpperCase()
    );
  }

  uploadFileObj: any = null;
  lifUploadConfirmation: any = {
    race: null,
    type: null,
    event: null
  };

  uploadFile(event: any, race: any, type: string) {
    event.stopPropagation();
    if (this.isORCompleted(race)) {
      this.lifUploadConfirmation = {
        race: race,
        type: type,
        event: event
      };
    } else {
      this.uploadFileObj = {
        type: type,
        race: race,
        raceCource: this.selected,
      };
    }
  }

  confirmLifUpload(confirmed: boolean) {
    if (confirmed) {
      this.uploadFileObj = {
        type: this.lifUploadConfirmation.type,
        race: this.lifUploadConfirmation.race,
        raceCource: this.selected,
      };
    }
    this.lifUploadConfirmation = {
      race: null,
      type: null,
      event: null
    };
  }

  querySubscription: Subscription;
  params: any = {};
  ngOnInit(): void {
    this.querySubscription = this.activeRoute.queryParams.subscribe(
      (params: any) => {
        if (params.event_id) {
          this.params['event_id'] = params.event_id;
        }
        if (params.race_id) {
          this.params['race_id'] = params.race_id;
        }
        if (params.date) {
          this.date = params.date;
        }
      }
    );
    this.startAutoRefresh(true);
  }

  config: any;
  constructor(
    private apiService: APIService,
    private notifier: NotifierService,
    private activeRoute: ActivatedRoute,
    private router: Router
  ) {
    this.config = this.activeRoute.snapshot.data['config'];
    this.startMonitoring();
  }

  selected: any = null;
  locations: any = [];
  races: any = [];
  async fetchEvents() {
    return new Promise(async (resolve: any) => {
      this.notifier.loading(true);
      this.selected = null;
      this.locations = [];
      this.races = [];
      const date = this.date
        ? moment(this.date, 'DD MMMM YYYY').format('YYYY-MM-DD')
        : moment().format('YYYY-MM-DD');
      let raceTypes: any = localStorage.getItem('raceTypes');
      if (raceTypes) {
        raceTypes = JSON.parse(raceTypes);
      }
      let apiURL: string = `${
        this.config[getENV()].raceAPI
      }/event-list?formatted_date=${date}`;

      if (raceTypes && raceTypes.length > 0) {
        apiURL += `&race_types=${raceTypes.join(',')}&trial=${typesSelected['trial']}`;
      }

      let result: any = await this.apiService.getDataPromis(apiURL, {}, {});

      if (result.eventNames && result.eventNames.length > 0) {
        result.eventNames = result.eventNames.filter((event: any) => {
          return checkForVenuePermission(event['external_venue_id']);
        });
        let resultEventNames = result.eventNames;

        resultEventNames.forEach((event: any, index: number) => {
          event['operator'] = null;
          let raceType = getRaceType(event['external_venue_id'])['raceTypeStr'];

          if (
            raceType == 'Thoroughbred Racing' &&
            event['venue_name'] == 'Cranbourne'
          ) {
            event['venue_name'] = 'Cranbourne Turf';
          }

          const jurisdiction = (typeBasedLocations[raceType] as any).find(
            (j: any) => {
              let location: any = j.Locations.find((location: any) => {
                return (
                  location.Name.toLowerCase() ==
                  event['venue_name'].toLowerCase()
                );
              });
              if (location) {
                event['type'] = location.type;
              }
              return location;
            }
          );

          if (jurisdiction) {
            event['State'] = jurisdiction.State;
            event['JurisdictionCode'] = jurisdiction.JurisdictionCode;
            event['Jurisdiction'] = jurisdiction.Jurisdiction;
            event['StateCode'] = jurisdiction['State'];
            event['RaceType'] = raceType;
            event['date'] = date;
          }

          event['name'] = event['venue_name'];
          event['id'] = event['external_event_id'];
          // this.loadEvent(event, index);
        });

        this.locations = resultEventNames;
        if (this.params.event_id) {
          const selectedEvent = this.locations.find(
            (event: any) => event.external_event_id === this.params.event_id
          );
          if (selectedEvent) {
            this.selectEvent(selectedEvent);
          } else {
            this.notifier.loading(false);
          }
        } else {
          this.notifier.loading(false);
        }
      } else {
        this.locations = [];
        this.notifier.loading(false);
      }
      resolve(true);
    });
  }

  stopPropagation(event: any) {
    event.stopPropagation();
  }

  actionConfirmation: any = {
    race: null,
    action: null,
  };
  confirmPopup(race: any, action: string = null) {
    if (!action) {
      action = race['statusSelected'];
    }
    if (action == 'ARM') {
      this.submitGrayHound(race, action);
      return;
    }
    this.actionConfirmation = {
      race: race,
      action: action,
    };
  }

  async closePopup(event: boolean) {
    if (event) {
      let race = this.races.find(
        (race: any) =>
          race['ExternalRaceId'] ===
          this.actionConfirmation['race']['ExternalRaceId']
      );
      let action: string = this.actionConfirmation['action'];
      this.submitGrayHound(race, action);
    }
    this.actionConfirmation = {
      race: null,
      action: null,
    };
  }

  private async submitGrayHound(
    race: any,
    action: string = null
  ): Promise<void> {
    race['loading'] = true;
    let apiURL: string = `${this.config[getENV()].raceAPI}/flask-operations`;
    let payload: any = {
      action: 'greyhounds_server_trigger',
      operation: action,
      race_id: race['ExternalRaceId'],
    };

    let result: any = await this.apiService.postDataPromis(apiURL, payload, {});

    if (result.status == '1' || result.s == '1') {
      this.notifier.alert('Success', '', 'Success', 'success', 5000);
    } else {
      this.notifier.alert('Info', '', result.error_message, 'info', 5000);
    }
    race['loading'] = false;
  }

  async reviewPDF(event: any, race: any, type: string = '.pdf') {
    event.stopPropagation();
    let apiURL: string = `${this.config[getENV()].raceAPI}/flask-operations`;

    let payload: any = {
      action: 'review_files',
      location:
        locationMappers[this.selected.venue_name] || this.selected.venue_name,
      race_number: race['SquentialRaceOrderNumber'],
      race_date: this.selected['date'],
      type: this.selected['RaceType'],
      event_id: this.selected['external_event_id'],
      race_id: race['ExternalRaceId'],
      file_extension: type,
    };

    if (type == '.csv') {
      payload['file_folder'] = 'tol';
    }

    let result: any = await this.apiService.postDataPromis(apiURL, payload, {});

    if (result.status === '1' || result.s === '1') {
      let a: HTMLAnchorElement = document.createElement('a');
      a.target = '_blank';
      a.download = result.presigned_url;
      a.href = result.presigned_url;
      a.click();
    } else {
      this.notifier.alert('Info', '', result.error_message, 'info', 5000);
    }
  }

  async selectEvent(event: any, loader: boolean = true) {
    this.eventCompleted = false;
    if (loader) {
      this.notifier.loading(true);
    }

    this.router.navigate(['/dash/on-course-ops/judges'], {
      queryParams: { event_id: event['external_event_id'], date: this.date },
    });
    this.selected = event;

    // this.loadEvent(event.external_event_id);

    const apiURL = `${
      this.config[getENV()].raceAPI
    }/getracedetails?ExternalVenueId=${
      event.external_venue_id
    }&ExternalEventId=${event.external_event_id}`;

    const expandedStates = new Map(
      this.races?.map((race) => [
        race.ExternalRaceId,
        race.isExpanded || false,
      ]) || []
    );

    let result = await this.apiService.getDataPromis(apiURL, {}, {});

    if (result && Array.isArray(result) && result.length > 0) {
      result.sort(
        (a, b) => a.SquentialRaceOrderNumber - b.SquentialRaceOrderNumber
      );

      result.forEach((race: any) => {
        race.rawRaceTime = race.RaceTime;
        race['statusSelected'] = '';
        race['disabled'] = true;
        race['eventName'] = event.name;
        race['RaceState'] = race['RaceState']?.replace(' ', '_');
        race['raceStatus'] = race['RaceState']?.toUpperCase() || 'PLANNED';
        race['RaceTimeStr'] = race['RaceTime'];
        race['RaceTime'] = convertTimestamp(
          race['RaceTime'],
          event['venue_state']
        );

        race['RaceTimeHTML'] = race['RaceTime'];

        race['queryParamsVenue'] = {
          event_id: race['ExternalEventId'],
          venue_id: race['ExternalVenueId'],
          date: race['eventDate'],
          event_name: race['eventName'],
        };

        race['queryParamsRace'] = {
          race_id: race['ExternalRaceId'],
        };

        race[
          'name'
        ] = `#${race['SquentialRaceOrderNumber']} ${race['RaceName']}`;
        race['id'] = race['SquentialRaceOrderNumber'];
      });

      this.races = result.map((race) => {
        this.processRaceStatus(race);
        this.processReportStatus(
          race,
          event.JurisdictionCode,
          event.StateCode,
          event.RaceType
        );
        return {
          ...race,
          isExpanded: expandedStates.get(race.ExternalRaceId) || false,
        };
      });

      if (this.selected['RaceType'] == 'Greyhound Racing') {
        await this.fetchRaceStatuses();
      }
      if (loader) {
        this.notifier.loading(false);
      }
    }
    this.clearAllTimers();
    if (this.races && this.races.length > 0) {
      this.updateRaceStatuses();
      this.startRefreshTimer();
      this.updateEventProgress();
    }
  }

  async fetchRaceStatuses() {
    const url = `${this.API_URL}/greyhound-monitor?action=races`;
    try {
      const response = await this.apiService.getDataPromis(url, {}, {});

      if (response.status == '1' || response.s == '1') {
        const races = response.races || [];
        this.races.forEach((race: any) => {
          let raceStatus = races.find(
            (r: any) => r.raceid == race.ExternalRaceId
          );
          if (raceStatus) {
            const previousState = race.RaceState.toUpperCase();
            race.RaceState = raceStatus.status.toUpperCase();
            race.RaceState = race.RaceState.replace(' ', '_');
            race['disabled'] = false;

            // Start/update timer if state changed
            if (previousState !== race.RaceState) {
              this.startRaceTimer(race);
            }
          }
        });
        this.updateRaceStatuses();
      }
    } catch (error) {
      console.error('Error fetching race statuses:', error);
    }
  }

  isORCompleted(race: any): boolean {
    const orButton = race.buttonActions?.find((button: any) => button.slug === 'OR');
    return orButton?.status === 'COMPLETED';
  }

  closeUploadLIF() {
    if (this.uploadFileObj.uploadStatus == 'COMPLETED') {
      this.uploadFileObj.race.RaceState = 'OFFICIAL';
      let OR = this.uploadFileObj?.race?.buttonActions?.find((button: any) => button.slug === 'OR');
      if (OR) {
        OR.status = 'COMPLETED';
      }
    }
    this.uploadFileObj = null;
  }

  async loadEntrants(race: any) {
    if (race.expanded) {
      race.expanded = false;
      return;
    }
    race.expanded = true;
    if (race.entrants && race.entrants.length > 0) {
      return;
    }
    race.loading = true;
    let apiURL: string = `${
      this.config[getENV()].raceAPI
    }/race-entrant-details?ExternalRaceId=${
      race.ExternalRaceId
    }&ExternalEventId=${race.ExternalEventId}`;

    let result: any = await this.apiService.getDataPromis(apiURL, {}, {});

    if (typeof result == 'string') {
      race.error = result;
      race.entrants = [];
      return;
    }
    race.entrants = result.entrants || [];
    race.entrants.forEach((horse: any) => {
      horse['RaceState'] = horse['RaceState']
        ? horse['RaceState'].toUpperCase()
        : 'PLANNED';
      horse['RaceStateNew'] = horse['RaceState'];
      horse['imagePath'] = (() => {
        if (result.code_type === 'HARNESS') {
          return `https://tsd-prd01-silks.s3.ap-southeast-2.amazonaws.com/Harness_Racing_Australia/${horse.StartNumber}.png`;
        } else if (this.selected.external_venue_id.includes('STC')) {
          return `https://tsd-prd01-silks.s3.ap-southeast-2.amazonaws.com/singapore/${horse.ExternalSilkID}.png`;
        } else if (this.selected.external_venue_id.startsWith('GR')) {
          return `https://tsd-prd01-silks.s3.ap-southeast-2.amazonaws.com/Greyhounds/${horse.StartNumber}.png`;
        } else {
          return `https://tsd-prd01-silks.s3.ap-southeast-2.amazonaws.com/Racing_Australia/${horse.ExternalSilkID}.png`;
        }
      })();
    });
    race.loading = false;
  }

  async saveHorseStatus(race: any) {
    return new Promise(async (resolve: any, reject: any) => {
      let eventData: any = {
        external_race_id: race.ExternalRaceId,
        track_id: race['TrackID'],
        track_name: race['Track'],
        race_state: race['RaceState'].toUpperCase(),
        update_data: {},
      };

      // Track used tag IDs to check for uniqueness
      const usedTagIds: Set<any> = new Set();
      let isValidationFailed = false;
      race.entrants.forEach((race_entrant: any) => {
        race_entrant.RaceState = race_entrant.RaceStateNew;
        let tag_sn = race_entrant.DeviceNumber || null;
        let trainer_name = race_entrant.ExternalTrainerID || null;
        let dns_id = race_entrant?.RaceState?.toUpperCase() == 'DNS' || false;
        let jockey_name = race_entrant?.ExternalJockeyID || null;
        let tag_id = race_entrant?.DeviceID || null;
        eventData['update_data'][race_entrant.ExternalAnimalID] = {
          tag: tag_id ? Number(tag_id) : null,
          tag_sn: tag_sn,
          trainer: trainer_name,
          jockey: jockey_name,
          is_dns: dns_id,
          barrier: race_entrant.BarrierNumber || '',
          state: race_entrant?.RaceState,
        };
      });
      const apiUrl = `${this.config[getENV()].raceAPI}/update-race-details`;
      const apiKey = 'U7RoenAJeFp21d07UQMY7Y1TAitCuR76nuXQJ8pg';
      const headers = { 'x-api-key': apiKey };
      this.notifier.loading(true);
      let result: any = await this.apiService.postDataPromis(
        apiUrl,
        eventData,
        headers
      );

      this.notifier.loading(false);
      resolve(true);
    });
  }
  async editRaceTime(race: any, newTime: string) {
    if (!this.isRaceTimeEditable(race)) {
      this.notifier.alert(
        'Error',
        '',
        'Cannot edit race time in current state',
        'error',
        5000
      );
      return;
    }

    const apiURL = `${this.config[getENV()].raceAPI}/update-race-time`;
    const payload = {
      race_id: race.ExternalRaceId,
      new_time: newTime,
    };

    try {
      await this.apiService.postDataPromis(apiURL, payload, {});
      race.RaceTime = newTime;
      this.notifier.alert(
        'Success',
        '',
        'Race time updated successfully',
        'success',
        5000
      );
    } catch (error) {
      this.notifier.alert(
        'Error',
        '',
        'Failed to update race time',
        'error',
        5000
      );
    }
  }

  private startRaceTimer(race: any): void {
    if (this.raceTimers[race.ExternalRaceId]) {
      clearInterval(this.raceTimers[race.ExternalRaceId]);
    }

    if (race.RaceState === 'RUNNING') {
      let startTime = Date.now();
      race.elapsedTime = '00:00:00';
      this.raceTimers[race.ExternalRaceId] = setInterval(() => {
        const elapsed = Date.now() - startTime;
        race.elapsedTime = new Date(elapsed).toISOString().substr(11, 8);
      }, 1000);
    } else if (race.RaceState === 'FINISHED') {
      clearInterval(this.raceTimers[race.ExternalRaceId]);
    } else if (race.RaceState === 'QA_PASSED') {
      clearInterval(this.raceTimers[race.ExternalRaceId]);
    } else if (race.RaceState === 'QA_FAILED') {
      clearInterval(this.raceTimers[race.ExternalRaceId]);
    }
  }

  private startAutoRefresh(firstTime: boolean = false): void {
    this.refreshInterval = setInterval(() => {
      if (this.selected && !this.showRaceTimePopup) {
        this.selectEvent(this.selected, firstTime);
      }
      firstTime = false;
    }, this.REFRESH_RATE);
  }

  private stopAutoRefresh(): void {
    if (this.refreshInterval) {
      clearInterval(this.refreshInterval);
    }
  }

  private clearAllTimers(): void {
    Object.values(this.raceTimers).forEach((timer) => clearInterval(timer));
    this.raceTimers = {};
  }

  showRaceTimePopup: boolean = false;
  selectedRace: any = null;
  newRaceTime: { hour: number; minute: number } = { hour: 0, minute: 0 };
  hours: number[] = Array.from({ length: 24 }, (_, i) => i);
  minutes: number[] = Array.from({ length: 60 }, (_, i) => i);

  openRaceTimePopup(race: any) {
    this.selectedRace = race;
    const [hour, minute] = race.RaceTime.split('H').map(Number);
    this.newRaceTime = { hour, minute };
    this.showRaceTimePopup = true;
  }

  closeRaceTimePopup() {
    this.showRaceTimePopup = false;
    this.selectedRace = null;
    this.newRaceTime = { hour: 0, minute: 0 };
  }

  addMinutes(minutes: number) {
    let time = moment({
      hour: this.newRaceTime.hour,
      minute: this.newRaceTime.minute,
    });
    time.add(minutes, 'minutes');
    this.newRaceTime.hour = time.hour();
    this.newRaceTime.minute = time.minute();
  }

  resetRaceTIme() {
    let raw = this.convertRaceTime(this.selectedRace.rawRaceTime);
    const [hour, minute] = raw.split('H').map(Number);
    this.newRaceTime = { hour, minute };
  }

  updateRaceTime() {
    if (this.selectedRace) {
      let raw = this.convertRaceTime(this.selectedRace.rawRaceTime);
      const [hour, minute] = raw.split('H').map(Number);
      const newRaceTime = `${this.newRaceTime.hour
        .toString()
        .padStart(2, '0')}H${this.newRaceTime.minute
        .toString()
        .padStart(2, '0')}`;
      if (this.newRaceTime.hour == hour && this.newRaceTime.minute == minute) {
        this.selectedRace.RaceTime = newRaceTime;
        this.selectedRace.timeChanged = false;
        this.selectedRace.RaceTimeHTML = newRaceTime;
        this.selectedRace.diffTime = 0;
      } else {
        const originalTime = moment({ hour, minute });
        const newTime = moment({
          hour: this.newRaceTime.hour,
          minute: this.newRaceTime.minute,
        });
        const diff = newTime.diff(originalTime, 'minutes');
        const diffFormatted = diff >= 0 ? `+${diff}m` : `${diff}m`;
        this.selectedRace.RaceTimeHTML = `${newRaceTime} <span class='fw-bold'>${diffFormatted}</span>`;
        this.selectedRace.RaceTime = newRaceTime;
        this.selectedRace.diffTime = diff;
        this.selectedRace.timeChanged = true;
        this.hasUnsavedTimeChanges = true; // Update global flag to show submit button
      }
      this.closeRaceTimePopup();
    }
  }

  convertRaceTime(time: string): string {
    return convertTimestamp(time, this.selected?.venue_state);
  }

  private initializeRaceStatus(): RaceStatus {
    return {
      PLANNED: 0,
      DNS: 0,
      DNT: 0,
      DNF: 0,
      DSQ: 0,
      OFFICIAL: 0,
      FINISHED: 0,
      'QA_PASSED': 0,
      'QA_FAILED': 0,
      PUBLISHED: 0,
      ABANDONED: 0,
      FTF: 0,
      SCR: 0,
      'L/SCR': 0,
      FELL: 0,
      DISTANCE: 0,
      RO: 0,
      BD: 0,
      LB: 0,
      LGO: 0,
      LGT: 0,
    };
  }

  raceTimer: any;
  async eachRaceTimer() {
    this.raceTimer = setInterval(() => {
      this.races.forEach((race: any) => {
        if (race.RaceState == 'ARM' || race.RaceState == 'SCHEDULED') {
          const now = moment.utc().valueOf();
          const raceTime = moment
            .utc(race.RaceTimeStr, 'YYYY-MM-DD-HH:mm:ss')
            .valueOf();
          const distance = raceTime - now;

          if (distance < 0) {
            clearInterval(this.bannerInterval);
            this.countdownTime = '';
            this.updateRaceStatuses();
          } else {
            const hours = Math.floor(distance / (1000 * 60 * 60));
            const minutes = Math.floor(
              (distance % (1000 * 60 * 60)) / (1000 * 60)
            );
            const seconds = Math.floor((distance % (1000 * 60)) / 1000);

            race.countdown = `${hours.toString().padStart(2, '0')}h ${minutes
              .toString()
              .padStart(2, '0')}m ${seconds.toString().padStart(2, '0')}s`;
            race.isUrgent = hours === 0 && minutes < 2;
          }
        }
      });
    }, 1000);
  }

  private processRaceStatus(race: Race): void {
    if (!race.RaceState) {
      race.RaceState = 'SCHEDULED';
    }

    race.RaceState = race.RaceState.toUpperCase();

    const states = [
      'SCHEDULED',
      'ARM',
      'RUNNING',
      'FINISHED',
      'ABANDONED',
      'PLANNED',
      'DNS',
      'DNT',
      'DNF',
      'DSQ',
      'OFFICIAL',
      'PUBLISHED',
      'QA_PASSED',
      'QA_FAILED',
      'FTF',
      'SCR',
      'L/SCR',
      'FELL',
      'DISTANCE',
      'RO',
      'BD',
      'LB',
      'LGO',
      'LGT',
    ];
    if (!states.includes(race.RaceState)) {
      race.RaceState = 'SCHEDULED';
    }
    race.status = this.initializeRaceStatus();
    race.RaceState = race.RaceState || 'PLANNED';
    race.raceStatus = race.RaceState;

    if (race.RaceState.toUpperCase() === 'ABANDONED') {
      race.status.ABANDONED = race.AnimalDetail.length;
    } else {
      race.AnimalDetail.forEach((animal) => {
        let status = 'PLANNED';
        animal.RaceState = animal.RaceState || 'PLANNED';

        if (animal.RaceState.toUpperCase() === 'PLANNED') {
          status =
            race.RaceState.toUpperCase() === 'FINISHED'
              ? 'FINISHED'
              : 'PLANNED';
        } else {
          status = animal.RaceState.toUpperCase();
        }

        race.status[status as keyof RaceStatus]++;
      });
    }
  }

  private processReportStatus(
    race: Race,
    jurisdictionCode: string,
    stateCode: string,
    raceType: string
  ): void {
    // Initialize default actions
    race.buttonActions = [
      { slug: 'OR', status: 'PLANNED', actions: [] },
      { slug: 'PDF', status: 'PLANNED', actions: [] },
      { slug: 'CUST', status: 'PLANNED', actions: [] },
      { slug: 'TSD', status: 'PLANNED', actions: [] },
    ];

    // Filter applicable actions based on jurisdiction
    const applicableActions = buttonActions.filter(
      (report: ButtonActionConfig) => {
        if (!report.conditions) return true;

        const condition = report.conditions.find(
          (c) => c.state === jurisdictionCode
        );
        if (!condition) return true;

        const { key, equation, value } = condition.condition;
        return equation === 'equals'
          ? race[key] === value
          : race[key] !== value;
      }
    );

    // Process each applicable action
    applicableActions.forEach((report: ButtonActionConfig) => {
      if (
        (report.states === 'ALL' ||
          (Array.isArray(report.states) &&
            (report.states.includes(jurisdictionCode) ||
              report.states.includes(stateCode)))) &&
        (!report.type || report.type === raceType)
      ) {
        const action = race.buttonActions.find((ba) => ba.slug === report.slug);
        if (action) {
          const reportStatus = race.ReportStatus?.find(
            (rs) => rs.StepType === report.action
          );

          action.actions.push({
            name: report.name,
            status: reportStatus
              ? reportStatus.StepCompletionStatus.toUpperCase()
              : 'PLANNED',
            comment: reportStatus?.Comments || '',
          });
        }
      }
    });

    // Update overall status for each button
    race.buttonActions.forEach((button) => {
      const hasCompleted = button.actions.some((a) => a.status === 'COMPLETED');
      const hasFailed = button.actions.some((a) => a.status === 'FAILED');
      button.status = hasFailed
        ? 'FAILED'
        : hasCompleted
        ? 'COMPLETED'
        : 'PLANNED';
    });

    // Remove empty action groups
    race.buttonActions = race.buttonActions.filter(
      (ba) => ba.actions.length > 0
    );
  }

  toggleRaceDetails(race: Race): void {
    race.isExpanded = !race.isExpanded;
    this.loadEntrants(race);
  }

  eventCompleted: boolean = false;
  private updateRaceStatuses(): void {
    const now = new Date();
    this.currentRace = null;
    this.nextRace = null;

    if (!this.currentRace) {
      // If no current race, find most recently finished race
      this.currentRace = [...this.races].reverse().find((race) => {
        return race.RaceState === 'FINISHED' || race.RaceState == 'RUNNING' || race.RaceState == 'QA_PASSED' || race.RaceState == 'QA_FAILED';
      });
    }

    if (
      this.currentRace &&
      (this.currentRace.RaceState === 'FINISHED' ||
        this.currentRace.RaceState == 'RUNNING' || this.currentRace.RaceState == 'QA_PASSED' || this.currentRace.RaceState == 'QA_FAILED')
    ) {
      // Find next scheduled/armed race
      if (this.currentRace.RaceState != 'RUNNING') {
        this.nextRace = this.races.find(
          (race) => race.RaceState === 'SCHEDULED' || race.RaceState === 'ARM' || race.RaceState === 'PLANNED'
        );
      }
    } else {
      this.currentRace = this.races[0];
      this.nextRace = null;
    }

    // If all races are finished, set currentRace to the last race and nextRace to null
    if (
      !this.nextRace &&
      this.currentRace &&
      (this.currentRace.RaceState === 'FINISHED'|| this.currentRace.RaceState == 'QA_PASSED' || this.currentRace.RaceState == 'QA_FAILED')
    ) {
      this.currentRace = this.races[this.races.length - 1];
      this.nextRace = null;
    }

    if (
      !this.nextRace &&
      (this.currentRace.RaceState == 'FINISHED' ||
        this.currentRace.RaceState == 'OFFICIAL' ||
        this.currentRace.RaceState == 'PUBLISHED' ||
        this.currentRace.RaceState == 'QA_PASSED' ||
        this.currentRace.RaceState == 'QA_FAILED' ||
        this.currentRace.RaceState == 'ABANDONED')
    ) {
      this.eventCompleted = true;
    }

    if (this.races.length > 0) {
      this.eachRaceTimer();
    }

    this.updateBanner();
  }

  isUrgent: boolean;
  private updateBanner(): void {
    if (this.bannerInterval) {
      clearInterval(this.bannerInterval);
    }

    if (
      this.nextRace &&
      ['SCHEDULED', 'ARM'].includes(this.nextRace.RaceState)
    ) {
      this.bannerInterval = setInterval(() => {
        const now = moment.utc().valueOf();
        const raceTime = moment
          .utc(this.nextRace.RaceTimeStr, 'YYYY-MM-DD-HH:mm:ss')
          .valueOf();
        const distance = raceTime - now;

        if (distance < 0) {
          clearInterval(this.bannerInterval);
          this.countdownTime = '';
          this.updateRaceStatuses();
        } else {
          const hours = Math.floor(distance / (1000 * 60 * 60));
          const minutes = Math.floor(
            (distance % (1000 * 60 * 60)) / (1000 * 60)
          );
          const seconds = Math.floor((distance % (1000 * 60)) / 1000);

          this.countdownTime = `${hours.toString().padStart(2, '0')}h ${minutes
            .toString()
            .padStart(2, '0')}m ${seconds.toString().padStart(2, '0')}s`;
          this.isUrgent = hours === 0 && minutes < 2;
        }
      }, 1000);
    }
  }

  private startMonitoring(): void {
    // Initial check
    this.checkHeartbeat();
    this.checkMylaps();

    // Check every 10 seconds
    this.monitoringInterval = setInterval(() => {
      this.checkHeartbeat();
      this.checkMylaps();
    }, 10000);
  }

  private async checkHeartbeat(): Promise<void> {
    try {
      const url = `${this.API_URL}/greyhound-monitor?action=heartbeat`;
      const response = await this.apiService.getDataPromis(url, {}, {});

      if (response.status == '1' || response.s == '1') {
        this.status.heartbeat = 'alive';
        this.heartbeatStatus = true;
      } else {
        this.status.heartbeat = 'down';
        this.heartbeatStatus = false;
      }
    } catch (error) {
      console.error('Error checking heartbeat:', error);
      this.status.heartbeat = 'down';
      this.heartbeatStatus = false;
    }
  }

  private async checkMylaps(): Promise<void> {
    try {
      const url = `${this.API_URL}/greyhound-monitor?action=mylaps`;
      const response = await this.apiService.getDataPromis(url, {}, {});

      if (response.status == '1' || response.s == '1') {
        this.status.lap = response.connection_status || 'NoConnection';
        this.mylapsStatus =
          response.connection_status === 'Connected' ||
          response.connection_status == 'alive';
      } else {
        this.status.lap = 'NoConnection';
        this.mylapsStatus = false;
      }
    } catch (error) {
      console.error('Error checking mylaps:', error);
      this.status.lap = 'NoConnection';
      this.mylapsStatus = false;
    }
  }

  private updateEventProgress(): void {
    if (!this.races) return;

    this.totalRaces = this.races.length;
    this.completedRaces = this.races.filter((race) =>
      ['FINISHED', 'OFFICIAL', 'PUBLISHED', 'ABANDONED', 'QA_PASSED', 'QA_FAILED'].includes(
        race.RaceState
      )
    ).length;
  }

  ngOnDestroy(): void {
    if (this.bannerInterval) {
      clearInterval(this.bannerInterval);
    }
    clearInterval(this.raceTimer);
    this.stopAutoRefresh();
    this.clearAllTimers();
    this.querySubscription.unsubscribe();
    if (this.statusCheckInterval) {
      clearInterval(this.statusCheckInterval);
    }
    if (this.monitoringInterval) {
      clearInterval(this.monitoringInterval);
    }
  }

  getRaceStatusClass(race: any): string {
    const status = race.RaceState?.toLowerCase();
    return status ? `race-status-${status}` : '';
  }

  loadingScratchings: boolean = false;

  // Update scratchings from the data provider
  async updateScratchings() {
    if (!this.selected) {
      this.notifier.alert('Warning', '', 'Please select an event first', 'warning', 3000);
      return;
    }

    this.loadingScratchings = true;
    try {
      let apiURL: string = `${this.config[getENV()].raceAPI}/scratching?${this.races
        .map((race) => {
          return `raceIds[]=${race.ExternalRaceId}`;
        })
        .join('&')}`;

      let result: any = await this.apiService.postDataPromis(apiURL, {}, {});

      if (result.status == '1' || result.s == '1') {
        this.notifier.alert(
          'Success',
          '',
          'Scratchings updated successfully',
          'success',
          5000
        );
        // Refresh the races to show updated scratching information
        await this.selectEvent(this.selected, false);
      } else {
        this.notifier.alert(
          'Error',
          '',
          result.error_message || 'Failed to update scratchings',
          'error',
          5000
        );
      }
    } catch (error) {
      console.error('Error updating scratchings:', error);
      this.notifier.alert(
        'Error',
        '',
        'An error occurred while updating scratchings',
        'error',
        5000
      );
    } finally {
      this.loadingScratchings = false;
    }
  }

  // Method to handle external race time updates API call
  async updateRaceTimesFromAPI(data: any) {
    if (!data || !data.races || !Array.isArray(data.races) || data.races.length === 0) {
      this.notifier.alert('Error', '', 'Invalid race time update data received', 'error', 5000);
      return;
    }

    this.notifier.loading(true);
    try {
      // Process each race update to calculate diffTime
      for (const raceUpdate of data.races) {
        const race = this.races.find(r => r.ExternalRaceId === raceUpdate.race_id);

        if (race) {
          // Parse the new scheduled time
          const newDateTime = moment(raceUpdate.scheduled_start_time);
          const displayTime = newDateTime.format('HH:mm');

          // Calculate the time difference in minutes
          const rawTime = race.rawRaceTime;
          const momentObj = moment(rawTime, 'YYYY-MM-DD-HH:mm:ss');
          const originalTime = momentObj.format('HH:mm');

          // Calculate time difference for diffTime
          const [origHour, origMinute] = originalTime.split(':').map(Number);
          const [newHour, newMinute] = displayTime.split(':').map(Number);
          const originalMoment = moment({ hour: origHour, minute: origMinute });
          const newMoment = moment({ hour: newHour, minute: newMinute });
          const diff = newMoment.diff(originalMoment, 'minutes');

          // Store race time difference for API
          race.diffTime = diff;

          // Update UI with the new time information
          race.RaceTime = `${newHour.toString().padStart(2, '0')}H${newMinute.toString().padStart(2, '0')}`;

          if (diff !== 0) {
            const diffFormatted = diff >= 0 ? `+${diff}m` : `${diff}m`;
            race.RaceTimeHTML = `${race.RaceTime} <span class='fw-bold'>${diffFormatted}</span>`;
            race.timeChanged = true;
          } else {
            race.RaceTimeHTML = race.RaceTime;
            race.timeChanged = false;
          }
        }
      }

      // Prepare the payload in the format expected by the API - keeping original structure
      const raceTimes = {};

      // Only include races that have diffTime (meaning they were changed)
      this.races.forEach(race => {
        if (race.diffTime) {
          // Calculate the adjusted time by applying diffTime to rawRaceTime
          const rawTime = race.rawRaceTime;
          const momentObj = moment(rawTime, 'YYYY-MM-DD-HH:mm:ss');
          momentObj.add(race.diffTime, 'minutes');
          raceTimes[race.ExternalRaceId] = momentObj.format('HH:mm');
        }
      });

      // Only proceed if we have race times to update
      if (Object.keys(raceTimes).length === 0) {
        this.notifier.alert('Info', '', 'No race time changes to submit', 'info', 5000);
        this.notifier.loading(false);
        return;
      }

      const payload = {
        action: "race_scheduled_times",
        raceTimes: raceTimes,
        eventID: this.selected.external_event_id
      };

      // Use the flask-operations API endpoint
      const apiURL = `${this.config[getENV()].raceAPI}/flask-operations`;

      const result = await this.apiService.postDataPromis(apiURL, payload, {});

      if (result && (result.status === '1' || result.s === '1')) {
        this.notifier.alert(
          'Success',
          '',
          `Successfully updated ${Object.keys(raceTimes).length} race time(s)`,
          'success',
          5000
        );
      } else {
        this.notifier.alert(
          'Error',
          '',
          result?.error_message || 'Failed to update race times',
          'error',
          5000
        );
      }
    } catch (error) {
      console.error('Error in updateRaceTimesFromAPI:', error);
      this.notifier.alert('Error', '', 'An error occurred while updating race times', 'error', 5000);
    } finally {
      this.notifier.loading(false);
    }
  }

  // Submit race time updates to the server
  async submitRaceTimeUpdates() {
    if (!this.races || this.races.length === 0 || !this.selected) {
      this.notifier.alert('Warning', '', 'No races available to update', 'warning', 3000);
      return;
    }

    // Get only races with time changes
    const racesWithChanges = this.races.filter(race => race.timeChanged);

    if (racesWithChanges.length === 0) {
      this.notifier.alert('Warning', '', 'No race time changes to submit', 'warning', 3000);
      return;
    }

    this.notifier.loading(true);

    try {
      // Prepare updated races with proper datetime format using rawRaceTime and diffTime
      const updatedRaces = racesWithChanges.map(race => {
        // Use the raw time and add the time difference to get the new time
        const momentObj = moment(race.rawRaceTime, 'YYYY-MM-DD-HH:mm:ss');
        // Apply the time difference
        momentObj.add(race.diffTime, 'minutes');

        // Format for API: YYYY-MM-DD HH:MM:SS
        const formattedDate = moment(this.date, 'DD MMMM YYYY').format('YYYY-MM-DD');
        const formattedTime = momentObj.format('HH:mm:00');
        const scheduledStartTime = `${formattedDate} ${formattedTime}`;

        return {
          race_id: race.ExternalRaceId,
          scheduled_start_time: scheduledStartTime
        };
      });

      // Make the API call to update race times - using the same payload structure as grayhound-monitoring
      const apiURL = `${this.config[getENV()].raceAPI}/flask-operations`;
      const payload = {
        action: "race_scheduled_times",
        races: updatedRaces
      };

      const result = await this.apiService.postDataPromis(apiURL, payload, {});

      if (result && (result.status === '1' || result.s === '1')) {
        // Reset timeChanged flag for successfully updated races
        if (result.updated_races && result.updated_races.length > 0) {
          const updatedRaceIds = result.updated_races.map(r => r.race_id);

          this.races.forEach(race => {
            if (updatedRaceIds.includes(race.ExternalRaceId)) {
              // Update rawRaceTime to the new time after successful submission
              const momentObj = moment(race.rawRaceTime, 'YYYY-MM-DD-HH:mm:ss');
              momentObj.add(race.diffTime, 'minutes');
              race.rawRaceTime = momentObj.format('YYYY-MM-DD-HH:mm:ss');
              race.RaceTimeStr = race.rawRaceTime;

              // Reset display state
              race.timeChanged = false;
              race.diffTime = 0;

              // Update display to show the new time without the diff indicator
              const raceTimeFormatted = race.RaceTime.split('H');
              race.RaceTimeHTML = `${raceTimeFormatted[0]}H${raceTimeFormatted[1]}`;
            }
          });

          this.hasUnsavedTimeChanges = false;
          this.notifier.alert(
            'Success',
            '',
            `Successfully updated ${result.updated_races.length} race time(s)`,
            'success',
            5000
          );
        }

        // Check if there were any failures
        if (result.failed_races && result.failed_races.length > 0) {
          const failedRaceIds = result.failed_races.map(f => f.race_id).join(', ');
          const mainReason = result.failed_races[0].reason || 'Unknown error';

          this.notifier.alert(
            'Partial Success',
            '',
            `Updated ${result.total_updated || 0} races. Failed to update ${result.total_failed || result.failed_races.length} races (${failedRaceIds}). Reason: ${mainReason}`,
            'warning',
            7000
          );
        }
      } else {
        // Handle error response
        const errorMessage = result.error || 'Unknown error occurred';
        this.notifier.alert(
          'Error',
          '',
          `Failed to update race times: ${errorMessage}`,
          'error',
          5000
        );
      }
    } catch (error) {
      console.error('Error updating race times:', error);
      this.notifier.alert('Error', '', 'An error occurred while updating race times', 'error', 5000);
    } finally {
      this.notifier.loading(false);
    }
  }
  // Helper method to check if race time can be edited
  isRaceTimeEditable(race: any): boolean {
    // Cannot edit race time if race is in these states
    const unEditableStates = ['FINISHED', 'PUBLISHED', 'OFFICIAL'];
    return !unEditableStates.includes(race.RaceState);
  }
}
